import { Actor, HttpAgent } from '@icp-sdk/core/agent';
import { Principal } from '@icp-sdk/core/principal';
import { idlFactory, type _SERVICE as Indexer } from '../bindings/indexer/declarations/indexer.did';
import { HOST } from './api';

export type HolderPage = NonNullable<Awaited<ReturnType<Indexer['holder_snapshot']>>[0]>;
export type IndexedHolder = HolderPage['items'][number];
export function indexResult(value: unknown) {
  if (value && typeof value === 'object' && 'err' in value) throw Error(String(value.err));
}

let actorPromise: Promise<ReturnType<typeof Actor.createActor<Indexer>>> | undefined;
export function holderIndex() {
  return actorPromise ??= (async () => {
    const id = import.meta.env.VITE_INDEXER_CANISTER_ID;
    if (!id) throw Error('The holder index canister has not been deployed.');
    const local = import.meta.env.VITE_DFX_NETWORK === 'local';
    const agent = await HttpAgent.create({ host: local ? import.meta.env.VITE_DFX_HOST : HOST, fetch: (input, init) => fetch(input, { ...init, signal: init?.signal ? AbortSignal.any([init.signal, AbortSignal.timeout(20_000)]) : AbortSignal.timeout(20_000) }) });
    if (local) await agent.fetchRootKey();
    return Actor.createActor<Indexer>(idlFactory, { agent, canisterId: id });
  })().catch(error => { actorPromise = undefined; throw error; });
}

export function holderPrincipal(text: string): Principal | null {
  return text.trim() ? Principal.fromText(text.trim()) : null;
}
